<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import HotelMap from '@/components/search/offers/HotelMap.vue'
    import TourMapInfoWindow from '@/components/tours/search/offers/TourMapInfoWindow.vue'
    import {h, render} from 'vue'

    @Component({mixins: [HotelMap]})
    export class TourSearchMap extends Vue {
        async load() {
            await this.initMap()
        }

        addMarker(offer) {
            let position
            if (offer.coordinates) {
                position = {
                    lat: offer.coordinates[0],
                    lng: offer.coordinates[1],
                }
            } else {
                return
            }

            if (this.markers.findIndex(marker => marker.position === position) !== -1) return

            //if (this.markers.find(marker => position === marker.position)) return;
            const marker = new this.google.maps.Marker({
                position,
                icon: this.createMarkerIcon(offer),
                data: offer,
                minPrice: 0,
            })

            marker.addListener('click', () => {
                if (!marker.infoWindow) {
                    this.showInfoWindow(marker)
                }
            })

            this.markers.push(marker)
            return marker
        }

        showInfoWindow(marker) {
            const markerWithInfoWindow = this.markers.find(marker => marker.infoWindow)
            if (markerWithInfoWindow) {
                markerWithInfoWindow.infoWindow.close()
                markerWithInfoWindow.infoWindow = null
            }
            const InfoWindowComponent = h(TourMapInfoWindow, {
                offer: marker.data,
                withLink: this.linkToHotels,
            })
            InfoWindowComponent.appContext = useNuxtApp().vueApp._context
            const content = document.createElement('div')
            render(InfoWindowComponent, content)
            marker.infoWindow = new this.google.maps.InfoWindow({content})
            this.google.maps.event.addListener(marker.infoWindow, 'closeclick', () => {
                marker.infoWindow.close()
                marker.infoWindow = null
            })
            marker.infoWindow.open(this.map, marker)
        }

        setMapPosition() {
            this.map.fitBounds(this.bounds)
            this.mapPositionInit = true
        }

        saveMapPosition() {}
    }

    export default {...toNative(TourSearchMap), ssrRender: HotelMap.ssrRender}
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';

    .map {
        position: fixed;

        @media #{map.get(settings.$display-breakpoints, 'xs')} {
            margin-left: -(settings.$container-padding-x);
        }

        > div {
            height: 100%;
        }
    }

    :deep(.custom-label) {
        background-color: rgb(var(--v-theme-primary)) !important;
        border: 3px solid white !important;
        border-radius: 20px;
        padding: 4px !important;
        color: white !important;
        position: absolute;
        top: 100px;
        left: 50%;
        transform: translateX(-25%);
    }
</style>
